import { useTracking } from 'react-tracking';

export const useManualPortfolioTracking = () => {
  const { trackEvent } = useTracking({
    type: 'track',
    subject: 'manual-portfolio',
  });

  return {
    trackManualPortfolioEvent: trackEvent,
  };
};
